/* eslint-disable @typescript-eslint/no-explicit-any */

const fetchWithTimeout = async (url: string, options: any, tm: number, AbortController: any): Promise<any> => {
  const controller = new AbortController();
  const { signal } = controller;

  const timeout = setTimeout(() => {
    controller.abort();
  }, tm);

  const req = await fetch(url, {
    ...options,
    signal,
  });

  clearTimeout(timeout);

  const result = await req.text();
  return result;
};

export default fetchWithTimeout;
